export default "__VITE_ASSET__fjCHV1og__"